import { enrollmentsPath } from '../enrollments/paths'

/** Find Enrollments: the enrollment pages' own list. */
export const findEnrollmentsPath = enrollmentsPath

/** Find Enrollments showing one person's, as User Details links to it. */
export function personEnrollmentsPath(userId: string): string {
  return `${findEnrollmentsPath}?${new URLSearchParams({ filter: `userId:equals:${userId}` }).toString()}`
}
